<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="1200px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t("View Purchase's Information") }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <!-- %%%%%%%%%%%%%%%%% Print Section Title %%%%%%%%%%%%%%%%% -->
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">{{ $t('Purchases') }}</th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Supplier Invoice Number') }}
                      </div>
                      <strong>{{ viewInfo.supplier_invoice_number || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Supplier Name') }}
                      </div>
                      <strong>{{ viewInfo.vender_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Bill Date') }}</div>
                      <strong v-if="viewInfo.bill_date">{{ viewInfo.bill_date }}</strong>
                      <strong v-else>-</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Payment Type') }}
                      </div>
                      <strong>{{ $t(viewInfo.cash_or_opening_balance) || '' }}</strong>
                    </td>
                    <td
                      class="td-padding-bottom not-printable"
                      v-if="viewInfo.attachment !== null"
                      style="width: 1px; white-space: nowrap;"
                    >
                      <v-chip dark color="primary">
                        <v-avatar>
                          <v-icon>insert_drive_file</v-icon>
                        </v-avatar>
                        <a
                          :href="`${baseUrls.images}/${viewInfo.attachment}`"
                          target="_blank"
                          style="color: white; text-decoration: none"
                        >
                          {{ $t('Click to View Attachment') }}
                        </a>
                      </v-chip>
                    </td>
                  </tr>
                </table>

                <table class="printed-table" cellspacing="0">
                  <thead>
                    <tr class="only-for-print">
                      <td>
                        <div class="header-space">&nbsp;</div>
                      </td>
                    </tr>
                    <tr>
                      <th class="pa-2 view-table-header">#</th>
                      <th class="view-table-header" pa-2>
                        {{ $t('Product') }}
                      </th>
                      <th class="view-table-header" pa-2 v-if="settings.production_collections === 'Active'">
                        {{ $t('Collections') }}
                      </th>
                      <th class="view-table-header" pa-2 v-if="settings.product_expiry === 'Active'">
                        {{ $t('Expiration Date') }}
                      </th>
                      <th class="view-table-header" pa-2>
                        {{ $t('Quantity') }}
                      </th>
                      <th class="view-table-header" pa-2>
                        {{ `${$t('Price')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" pa-2>
                        {{ `${$t('Total')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" pa-2 v-if="settings.purchase_tax === 'Active'">
                        {{ `${$t('Tax')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" pa-2>
                        {{ `${$t('Transport Cost')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" pa-2>
                        {{ `${$t('Item Cost')} (${systemCurrency})` }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rowNumbers" :key="index">
                      <td class="view-table-row">
                        <p class="view-table-content">{{ index + 1 }}</p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.product_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row" v-if="settings.production_collections === 'Active'">
                        <p class="view-table-content">
                          {{ viewInfo.collection_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row" v-if="settings.product_expiry === 'Active'">
                        <p class="view-table-content">
                          {{ viewInfo.expire_date[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.purchase_quantity[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.purchase_price[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.total[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row" v-if="settings.purchase_tax === 'Active'">
                        <p class="view-table-content">
                          {{ viewInfo.purchase_tax[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.purchase_transport[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ itemCost(index) | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency">
                      <td class="last-table-row" :colspan="getColSpan()">
                        <p class="view-table-content">
                          {{ `${$t('Total Amount')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.total_amount | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency">
                      <td class="last-table-row" :colspan="getColSpan()">
                        <p class="view-table-content">
                          {{ `${$t('Transport Cost')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.transport_cost | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency">
                      <td class="last-table-row" :colspan="getColSpan()">
                        <p class="view-table-content">
                          {{ `${$t('Other Cost')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.other_cost | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency">
                      <td class="last-table-row" :colspan="getColSpan()">
                        <p class="view-table-content">
                          {{ `${$t('Grand Total Tax')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.tax | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency">
                      <td class="last-table-row" :colspan="getColSpan()">
                        <p class="view-table-content">
                          {{ `${$t('Grand Total Amount')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.grand_total_amount | currency }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="only-for-print">
                      <td>
                        <div style="height: 50px">&nbsp;</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <v-layout row wrap justify-center mt-4 v-if="paymentNumbers > 0">
                  <table>
                    <tr>
                      <th class="section-title-content">
                        {{ $t('Payment Details') }}
                      </th>
                    </tr>
                  </table>

                  <v-flex xs10>
                    <v-divider />
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="invoice-content" mt-4 v-if="paymentNumbers > 0">
                  <v-flex xs12 sm12>
                    <v-layout row wrap>
                      <table class="printed-table" cellspacing="0">
                        <thead>
                          <tr>
                            <th xs1 class="pa-2 view-table-header">#</th>
                            <th class="view-table-header" xs3 pa-2>
                              {{ $t('Recipient Name') }}
                            </th>
                            <th class="view-table-header" xs3 pa-2>
                              {{ $t('Date') }}
                            </th>
                            <th class="view-table-header" xs2 pa-2>
                              {{ `${$t('Amount')} (${systemCurrency})` }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in paymentNumbers" :key="index">
                            <td class="view-table-row">
                              <p class="view-table-content">{{ index + 1 }}</p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ paymentDetail.recipient_name[index] }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ paymentDetail.date[index] }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ paymentDetail.amount[index] | currency }}
                              </p>
                            </td>
                          </tr>
                          <tr class="last-table-row-for-currency">
                            <td class="last-table-row" colspan="3">
                              <p class="view-table-content">
                                {{ `${$t('Total Paid')}` }}
                              </p>
                            </td>
                            <td class="last-table-row2">
                              <p class="view-table-content">
                                {{ paymentDetail.total_paid | currency }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="only-for-print">
                            <td>
                              <div class="footer-space">&nbsp;</div>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <invoice-footer
                  :showSignatureSection="false"
                  :accountantName="''"
                  :payerRecipientName="''"
                  :payerOrRecipient="''"
                  class="only-for-print"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      viewInfo: {
        purchase_id: 0,
        supplier_invoice_number: '',
        cash_or_opening_balance: '',
        attachment: '',
        vender_name: '',
        bill_date: '',
        total_amount: '',
        transport_cost: '',
        other_cost: '',
        tax: '',
        grand_total_amount: '',
        product_name: [],
        collection_name: [],
        purchase_quantity: [],
        purchase_price: [],
        purchase_tax: [],
        total_tax: [],
        purchase_transport: [],
        total_transport: [],
        expire_date: [],
        total: []
      },
      rowNumbers: 0,
      hasPaymentDetail: false,
      paymentNumbers: 0,
      paymentDetail: {
        total_paid: 0,
        recipient_name: [],
        date: [],
        amount: []
      }
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      purchaseInfo: 'purchases/getPurchaseInfo',
      settings: 'configurations/getSystemSettings'
    }),
    hasExpiry() {
      return this.settings.product_expiry === 'Active'
    },
    hasTax() {
      return this.settings.purchase_tax === 'Active'
    },
    hasCollection() {
      return this.settings.production_collections === 'Active'
    },
    hasOpeningBalance() {
      return this.settings.opening_balance_status === 'Active'
    },
    twoOfThem() {
      return (
        (this.hasExpiry ? this.hasTax || this.hasCollection : this.hasTax && this.hasCollection) && !this.bothOfThem
      )
    },
    bothOfThem() {
      return this.hasExpiry && this.hasTax && this.hasCollection
    }
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.rowNumbers = this.purchaseInfo.data_detail.length
          this.viewInfo.supplier_invoice_number = this.purchaseInfo.data.supplier_invoice_number
          this.viewInfo.cash_or_opening_balance = this.purchaseInfo.data.cash_or_opening_balance
          this.viewInfo.vender_name = this.purchaseInfo.data.vender_name
          this.viewInfo.bill_date = this.purchaseInfo.data.bill_date

          this.viewInfo.total_amount = this.purchaseInfo.data.total_amount
          this.viewInfo.transport_cost = this.purchaseInfo.data.transfer_cost
          this.viewInfo.other_cost = this.purchaseInfo.data.other_cost
          this.viewInfo.tax = this.purchaseInfo.data.tax
          this.viewInfo.grand_total_amount = this.purchaseInfo.data.grand_total_amount
          this.viewInfo.attachment = this.purchaseInfo.data.attachment
          this.viewInfo.purchase_id = Number(this.purchaseInfo.data.purchase_id)

          this.viewInfo.product_name = []
          this.viewInfo.collection_name = []
          this.viewInfo.purchase_quantity = []
          this.viewInfo.purchase_price = []
          this.viewInfo.purchase_tax = []
          this.viewInfo.total_tax = []
          this.viewInfo.purchase_transport = []
          this.viewInfo.total_transport = []
          this.viewInfo.expire_date = []
          this.viewInfo.total = []

          this.purchaseInfo.data_detail.forEach(c => {
            this.viewInfo.product_name.push(c.product_name)
            this.viewInfo.collection_name.push(c.collection_name)
            if (c.collection_name !== null) {
              this.viewInfo.purchase_quantity.push(c.purchase_collection_quantity)
              this.viewInfo.purchase_price.push(c.purchase_collection_price)
              this.viewInfo.purchase_tax.push(c.purchase_collection_tax)
              this.viewInfo.total.push(c.total_collection)
              this.viewInfo.total_tax.push(c.total_collection_tax)
            } else {
              this.viewInfo.purchase_quantity.push(c.purchase_quantity)
              this.viewInfo.purchase_price.push(c.purchase_price)
              this.viewInfo.purchase_tax.push(c.purchase_tax)
              this.viewInfo.total.push(c.total)
              this.viewInfo.total_tax.push(c.total_tax)
            }
            this.viewInfo.purchase_transport.push(c.purchase_transfer)
            this.viewInfo.total_transport.push(c.total_transfer)
            this.viewInfo.expire_date.push(c.expire_date)
          })

          this.hasPaymentDetail = this.purchaseInfo.payment_detail !== null
          if (this.hasPaymentDetail) {
            this.paymentNumbers = this.purchaseInfo.payment_detail.length
            this.paymentDetail.total_paid = this.purchaseInfo.data.paid
            this.purchaseInfo.payment_detail.forEach(c => {
              this.paymentDetail.recipient_name.push(c.recipient_name)
              this.paymentDetail.date.push(c.payment_date)
              this.paymentDetail.amount.push(c.amount)
            })
          }
        }
      }
    }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    itemCost(index) {
      const itemCost =
        this.purchaseInfo.data_detail[index].purchase_price +
        this.viewInfo.purchase_tax[index] +
        this.viewInfo.purchase_transport[index]

      return this.viewInfo.collection_name[index]
        ? itemCost * this.purchaseInfo.data_detail[index].collection_quantity
        : itemCost
    },
    getColSpan() {
      if (this.bothOfThem) {
        return 9
      } else if (this.twoOfThem) {
        return 8
      } else if (this.hasExpiry || this.hasTax || this.hasCollection) {
        return 7
      } else {
        return 6
      }
    },
    printMe() {
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      document.querySelector('.printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
